export enum AnnexProcessStep {
  BasicData = 1,
  ChangedData = 2,
  Summary = 3,
}
